import React, { useState } from "react";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import { FaAndroid } from "react-icons/fa";
import { categories } from "../../data/posts";

function Header() {
  const [show, setShow] = useState(false);
  const close = () => setShow(false);

  return (
    <header>
      {/* Logo + search bar */}
      <div className="topbar py-3">
        <Container>
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
            <Link to="/" className="site-logo">
              <span className="logo-badge">APK</span>
              <span className="logo-rest">Downloads</span>
            </Link>
          </div>
        </Container>
      </div>

      {/* Category navigation (offcanvas on mobile) */}
      <Navbar expand="lg" className="cat-nav" variant="dark">
        <Container>
          <Navbar.Toggle
            aria-controls="cat-offcanvas"
            onClick={() => setShow(true)}
            className="ms-auto"
          />
          <Navbar.Offcanvas
            id="cat-offcanvas"
            aria-labelledby="cat-offcanvas-label"
            placement="start"
            show={show}
            onHide={close}
            className="cat-offcanvas"
          >
            <Offcanvas.Header closeButton closeVariant="white">
              <Offcanvas.Title id="cat-offcanvas-label" className="site-logo text-white">
                <FaAndroid className="me-2" /> Menu
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="me-auto">
                <Nav.Link as={NavLink} to="/" end onClick={close}>Home</Nav.Link>
                {categories.map((c) => (
                  <Nav.Link
                    as={NavLink}
                    to={`/category/${c.slug}`}
                    key={c.slug}
                    onClick={close}
                  >
                    {c.name}
                  </Nav.Link>
                ))}
                <Nav.Link as={NavLink} to="/calculators" onClick={close}>Calculators</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
